export default {"src":"/_next/static/media/saveMore.405a3fe7.svg","height":60,"width":69};